import assets, { getDay } from "src/isf-2025/assets";
import GRID from "src/isf-2025/components/GRID";
import { achievement } from "src/isf-2025/utils";
import { MappedImage } from "src/utils/fw";

export default function LeftBanner() {
    const day = getDay()

    const links = []

    const subscribeURL = "https://www.securityforum.org/spotlight-on/?utm_source=tk_digital&utm_medium=digital_platform&utm_campaign=2025_Congress_Prague&utm_id=2025_Congress_Prague"

    if (day <= 2) links.push({
        height: "7.1%",
        onClick() {
            window.open(subscribeURL)
        },
        label: "Subscribe to ISF Podcast",
        left: "37.8%",
        top: "78.7%",
        width: "24.3%",
    })

    if (!assets.exploration_zone.popups.leftBoard[day]) return <></>

    const data = assets.exploration_zone.popups.leftBoard[day]

    if (data.achievement) achievement(data.achievement)

    if (day === 3) {
        links.push({
            height: "10%",
            // href: subscribeURL,
            onClick() {
                window.open(subscribeURL)
            },
			label: "Subscribe to ISF Podcast",
            // target: "_blank",
			left: "37.8%",
			top: "71.7%",
			width: "24.3%",
        })
    }

    
    return <MappedImage imageURL={data.image} links={links}>
        
        { Array.isArray(data.link) && data.grid && <GRID 
            roomName="Exploration Zone"
            style={data.grid.GRID.style}
            links={data.link}
            onClickExtra={extra => achievement(extra)}
        /> }
        { !Array.isArray(data.link) && <iframe
            src={data.link}
            style={{
                position: "absolute",
                width: "84.6%",
                height: "27.3%",
                top: "43.6%",
                left: "7.9%",
                border:0
            }}
        /> }
    </MappedImage>
}
